export const WHATS_INSIDE = {
  heading: "What's inside a Gousto food box?",
  intro:
    "We pack our food boxes with everything you need to whip up seriously tasty meals, while keeping things as environmentally friendly as possible. To say we love food is an understatement, which is why we're committed to providing meals that leave the planet better off.",
  subheading: "Here's what you'll get:",
  benefits: [
    {
      icon: '📦',
      title: 'A sturdy, recyclable Gousto box',
      description: '(tough enough to handle food box deliveries, kind enough for the planet).',
    },
    {
      icon: '🥕',
      title: 'Super fresh, top-quality ingredients',
      description:
        'that are perfectly measured, cutting food waste to zero, both in your kitchen and in our factory.',
    },
    {
      icon: '🧊',
      title: 'Clever packaging that keeps everything cool',
      description: 'crisp, and ready to cook.',
    },
    {
      icon: '📋',
      title: 'Recipe cards that are so easy to follow',
      description: "you'll feel like a pro in the kitchen (even if you're not).",
    },
  ],
  footer:
    "Basically, it's everything you need from a subscription food box to show dinner who's boss.",
  altText:
    'Open Gousto box showing fresh vegetables, fridge items in a chill box and recipe instruction cards',
  ctaText: 'Try Gousto with 50% off',
}
